var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedTestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93179 8.57958H8.60475V5.95007H9.93179M9.93179 11.2091H8.60475V9.89433H9.93179M3.36361 13.1812H15.1729C15.6148 13.1812 15.9729 12.823 15.9729 12.3812C15.9729 12.2394 15.9352 12.1001 15.8636 11.9776L9.95898 1.87307C9.73607 1.4916 9.24611 1.36306 8.86464 1.58598C8.74585 1.65539 8.64697 1.75428 8.57755 1.87307L2.67289 11.9776C2.44998 12.3591 2.57851 12.849 2.95998 13.0719C3.08245 13.1435 3.22176 13.1812 3.36361 13.1812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTestIcon);
export default __webpack_public_path__ + "static/media/FailedTestIcon.4ac1424fa3e2920772a26b3aaa2292cd.svg";
export { ForwardRef as ReactComponent };